import { useEffect, useState } from "react";
import { EventDateInfo } from "../models/common";
import { getEventDateInfo } from "../buy-ticket-api";

export function useEventDateInfo(eventDateId: number): [ EventDateInfo, boolean ] {
    const [processing, setProcessing] = useState(true);
    const [result, setResult] = useState<EventDateInfo>(null);

    useEffect(() => {
        if(eventDateId) {
            setProcessing(true);

            const fetchSeatStatus = async () => {
                const result = await getEventDateInfo(eventDateId);
                setResult(result);
                setProcessing(false);
            };
            fetchSeatStatus();
        } else {
            setProcessing(false);
            setResult(null);
        }
    }, [eventDateId]);

    return [ result, processing ];
}